import { render } from "./Content.vue?vue&type=template&id=238716ab&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=238716ab&scoped=true&lang=css"

import exportComponent from "D:\\WORKSPACE\\Netbeans\\lz06\\2022xiongmao\\xiongmao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238716ab"]])

export default __exports__